import Form from './bjForm/bjForm.vue'; 
import Table from './bjTable/bjTable.vue'; 
import Dialog from './bjDialog/bjDialog.vue'; 
import Upload from './bjUpload/bjUpload.vue'; 
import Search from './bjSearch/bjSearch.vue'; 
import Select from './bjSelect/index.vue'; 
import SelectRemote from './bjSelect/remote.vue'; 

export default {
  install(Vue) {
    Vue.component(Form.name, Form); 
    Vue.component(Table.name, Table); 
    Vue.component(Dialog.name, Dialog);
    Vue.component(Upload.name, Upload);
    Vue.component(Search.name, Search);
    Vue.component(Select.name, Select);
    Vue.component(SelectRemote.name, SelectRemote)
  }
};
